<script>
import { makeID } from '../../Modules/Strings.js';

export default {
  props: {
    modelValue: String | Number,
    options: {
      type: Object,
      default: {},
    },
    order: {
      Type: String,
      default: '',
    },
    empty: {
      type: Boolean,
      default: true,
    },
    emptyDisabled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    resizeable: {
      type: Boolean,
      default: false,
    },

    emptyPlaceholder: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: 'form-control form-select-lg',
    },
  },

  emits: ['update:modelValue'],

  data() {
    return {
      id: null,
      current_value: this.modelValue,
      sorted_options: [],
    };
  },

  watch: {
    modelValue(newValue, oldValue) {
      this.current_value = newValue;
      this.resize();
    },

    current_value(newValue, oldValue) {
      if (newValue !== undefined) {
        this.resize();
      }
    },

    options(newValue, oldValue) {
      let key = Object.keys(newValue);
      if (key === undefined) {
        return;
      }
      if (key.length > 0) {
        this.sorted_options = this.buildSortedOptions(newValue);
        if (this.order != '') {
          this.reorder();
        }
        this.resize();
      } else {
        this.sorted_options = [];
      }
    },
  },

  created() {
    this.id = makeID(10);
  },

  mounted() {
    this.reorder();
  },

  methods: {
    normalizeOption(option) {
      if (option && typeof option === 'object' && !Array.isArray(option)) {
        return {
          label: option.label ?? '',
          style: option.style ?? null,
          class: option.class ?? '',
        };
      }

      return {
        label: option ?? '',
        style: null,
        class: '',
      };
    },

    buildSortedOptions(options = this.options) {
      return Object.entries(options || {}).map(([value, option]) => {
        const normalized = this.normalizeOption(option);
        return {
          value,
          label: normalized.label,
          style: normalized.style,
          class: normalized.class,
        };
      });
    },

    resize() {
      if (!this.resizeable) {
        return;
      }
      let selectId = document.getElementById(this.id);

      let width = 250;
      Object.keys(this.options).forEach((key) => {
        let option = this.normalizeOption(this.options[key]).label;
        let optionLength = 20 + String(option).length * 8;
        if (optionLength > width) {
          width = optionLength;
        }
      });
      selectId.style.width = width + 'px';
    },
    reorder() {
      // Sets the options object to an array so it can be reordered
      if (this.order == '' || this.sorted_options.length === 0) {
        this.sorted_options = this.buildSortedOptions();
        return;
      }
      if (this.order === 'asc') {
        this.sorted_options = this.buildSortedOptions().sort((a, b) =>
          String(a.label).localeCompare(String(b.label)),
        );
      } else if (this.order === 'desc') {
        this.sorted_options = this.buildSortedOptions().sort((a, b) =>
          String(b.label).localeCompare(String(a.label)),
        );
      }
    },
  },
};
</script>

<template>
  <select
    :id="id"
    :disabled="disabled"
    :class="class"
    @change="$emit('update:modelValue', $event.target.value)"
  >
    <option v-if="empty === true" value="" :disabled="emptyDisabled" selected>
      {{ emptyPlaceholder?.length > 0 ? emptyPlaceholder : '--' }}
    </option>
    <option
      v-for="(option, index) in sorted_options"
      :key="option.value"
      :class="option.class"
      :selected="option.value == modelValue"
      :style="option.style"
      :value="option.value"
    >
      {{ option.label }}
    </option>
  </select>
</template>
